export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="10" fill="#090A0F" />
    <path
      d="M24 7.5 37.5 14v10c0 7.6-5.9 13.4-13.5 15.9C16.4 37.4 10.5 31.6 10.5 24V14L24 7.5Z"
      stroke="#FFFFFF"
      strokeWidth="2.4"
      strokeLinejoin="round"
    />
    <path d="M16.5 20.5h15M24 20.5v10" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" />
    <circle cx="16.5" cy="20.5" r="2.1" fill="#FFFFFF" />
    <circle cx="31.5" cy="20.5" r="2.1" fill="#FFFFFF" />
    <circle cx="24" cy="30.5" r="3" fill="#00F0FF" className="animate-pulse-dot" />
  </svg>
);

export const Logo = ({ light = true }) => (
  <a
    href="#hero"
    data-testid="logo-home-link"
    className="group flex items-center gap-3"
    aria-label="Tecnología e Innovación de Occidente — Inicio"
  >
    <LogoMark className="h-9 w-9 transition-transform duration-500 group-hover:rotate-[-4deg]" />
    <span className="leading-none">
      <span className="block font-heading text-lg font-extrabold tracking-[0.08em] text-white">
        TIO
        <span className="ml-1 inline-block h-1.5 w-1.5 rounded-full bg-neon align-super" />
      </span>
      <span
        className={`mt-1 block font-mono text-[9px] uppercase tracking-[0.22em] ${
          light ? "text-slate-400" : "text-slate-500"
        }`}
      >
        Tecnología e Innovación de Occidente
      </span>
    </span>
  </a>
);

export default Logo;
